export const SIZE = {
	SMALL: 'small',
	DROPDOWN: 'dropdown',
	TAB: 'tab',
	STANDARD: 'standard',
	BIG: 'big',
	EXTRA_BIG: 'extra_big',
	MEDIUM: 'medium',
};

export function getDimensions(size) {
	switch (size) {
		case SIZE.SMALL:
			return '15';
		case SIZE.DROPDOWN:
			return '20';
		case SIZE.TAB:
			return '24';
		case SIZE.MEDIUM:
			return '35';
		case SIZE.BIG:
			return '65';
		case SIZE.EXTRA_BIG:
			return '90';
		case SIZE.STANDARD:
		default:
			return '28';
	}
}
